<div class="user-search-container">
  <mat-form-field class="q9-form-field q9-full-width" [floatLabel]="'always'" appearance="outline">
    <mat-label>{{ 'POPUPS.NAME_OR_EMAIL' | translate }}</mat-label>
    <input
      matInput
      required
      minlength="2"
      cdkFocusInitial
      (focus)="error = null"
      [matAutocomplete]="auto"
      [formControl]="assigneeFormControl"
      [errorStateMatcher]="this" />

    <mat-hint>{{ 'POPUPS.ENTER_NAME_OR_EMAIL' | translate }}</mat-hint>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayAssignee"
      (optionSelected)="onSelectAssigneeHandler($event)"
      autoActiveFirstOption="true">
      <mat-option
        class="assignee-option"
        *ngFor="let user of assignees$ | async"
        [value]="user.email || user">
        <q9-user-info class="q9-user-info assignee" [user]="user"></q9-user-info>
      </mat-option>

      <mat-option *ngIf="showUnassigned" class="assignee-option" value="Unassigned">
        {{ 'SIDEBAR.ASSIGNEE_UNASSIGNED' | translate }}
      </mat-option>
    </mat-autocomplete>

    <mat-error class="error-message" *ngIf="matError">{{ matError | translate }}</mat-error>
  </mat-form-field>
</div>
